import { useCallback } from 'react'
import { useDeleteProjectMembersMutation } from '@crew/apis/project/projectApis'
import { useAppDispatch } from 'states/hooks'
import { ProjectMember, Project } from '@crew/models/domain'
import { NotifyEventType } from 'enums/app'
import {
  ObjectEventMessage,
  notifyProjectMemberEvent,
  notifyProjectEvent,
} from 'features/app/states/appSlice'

export const useMemberTable = () => {
  const dispatch = useAppDispatch()

  // プロジェクトメンバー削除API
  const [
    deleteProjectMembersMutation,
    { isLoading: isLoadingDeleteGroupMember },
  ] = useDeleteProjectMembersMutation()

  // メンバー削除処理（単体）
  const deleteGroupMember = useCallback(
    async (projectId: string, userId: string) => {
      await deleteProjectMembersMutation({
        projectId,
        userIds: [userId],
      }).unwrap()

      // メンバーリストの再取得通知
      const objectEventMessageProjectMember: ObjectEventMessage<ProjectMember> =
        {
          eventType: NotifyEventType.Deleted,
          id: userId,
          object: {
            projectId,
            userId,
          },
        }
      dispatch(notifyProjectMemberEvent(objectEventMessageProjectMember))

      // ヘッダーメンバーの再取得通知
      const objectEventMessageProject: ObjectEventMessage<Project> = {
        eventType: NotifyEventType.Updated,
        id: projectId,
        object: {
          id: projectId,
        },
      }
      dispatch(notifyProjectEvent(objectEventMessageProject))
    },
    [deleteProjectMembersMutation, dispatch]
  )

  return {
    deleteGroupMember,
    isLoadingDeleteGroupMember,
  }
}
